import request from "@/api/request";

class User {
  login(data) {
    return request({
      url: "/api/login",
      method: "post",
      data: data
    });
  }

  add(data){
    return request({
      url: "/api/user/add",
      method: "post",
      data: data
    });
  }

  edit(data){
    return request({
      url: "/api/user/edit",
      method: "post",
      data: data
    });
  }

  delete(data){
    return request({
      url: "/api/user/delete",
      method: "post",
      data: data
    });
  }

  getToken(){
    return request({
      url: "/api/login",
      method: "get"
    });
  }

  getUserLists(data){
    return request({
      url: "/api/user/lists",
      method: "post",
      data: data
    });
  }

  getUser(){
    return request({
      url: "/api/user",
      method: "get"
    });
  }

  updateUser(data){
    return request({
      url: "/api/user",
      method: "post",
      data: data
    });
  }

  getByUID(data){
    return request({
      url: "/api/user/getupdate",
      method: "post",
      data: data
    });
  }
}

export default new User();
